import { AppShell } from './components/AppShell';
import { Loading } from './components/Loading';
import { useAuth } from './lib/auth';
import { Navigate, useLocation } from './lib/router';
import { AccountPage } from './pages/AccountPage';
import { AdminsPage } from './pages/AdminsPage';
import { AuditPage } from './pages/AuditPage';
import { CustomerDetailPage } from './pages/CustomerDetailPage';
import { CustomersPage } from './pages/CustomersPage';
import { DashboardPage } from './pages/DashboardPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { LoginPage } from './pages/LoginPage';
import { MfaSetupPage } from './pages/MfaSetupPage';
import { PagaquiSettingsPage } from './pages/PagaquiSettingsPage';
import { PagaquiVouchersPage } from './pages/PagaquiVouchersPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';

export default function App() {
  const { admin, loading } = useAuth();
  const { pathname } = useLocation();
  if (loading) {
    return <div className="app-loading"><Loading label="A validar a sessão" /></div>;
  }
  if (!admin) {
    if (pathname === '/login') return <LoginPage />;
    if (pathname === '/forgot-password') return <ForgotPasswordPage />;
    if (pathname === '/reset-password') return <ResetPasswordPage />;
    return <Navigate to="/login" />;
  }
  if (pathname === '/login') return <Navigate to="/" />;
  if (!admin.mfaEnabled) return <MfaSetupPage />;

  let page = <DashboardPage />;
  if (pathname === '/customers') page = <CustomersPage />;
  else if (/^\/customers\/[^/]+$/.test(pathname)) page = <CustomerDetailPage />;
  else if (
    pathname === '/audit' &&
    ['SUPER_ADMIN', 'AUDITOR', 'COMPLIANCE'].includes(admin.role)
  ) page = <AuditPage />;
  else if (pathname === '/admins' && admin.role === 'SUPER_ADMIN') {
    page = <AdminsPage />;
  } else if (
    pathname === '/pagaqui/settings' &&
    ['SUPER_ADMIN', 'OPERATIONS'].includes(admin.role)
  ) {
    page = <PagaquiSettingsPage />;
  } else if (
    pathname === '/pagaqui/vouchers' &&
    ['SUPER_ADMIN', 'OPERATIONS'].includes(admin.role)
  ) {
    page = <PagaquiVouchersPage />;
  } else if (pathname === '/account') {
    page = <AccountPage />;
  } else if (pathname !== '/') {
    return <Navigate to="/" />;
  }

  return <AppShell>{page}</AppShell>;
}
